import Icon, { ICON_WARNING_LINE } from '~/components/icon';
import IconButtonClose from '~/components/misc/icon-button-close';

const LimitNotification = ({ updateTime, message, iconCloseCallback }) => (
	<li data-at="limits-notification-element">
		<div
			data-at="limits-notification-wrapper "
			className="limits-notification-wrapper u-b-radius u-mb1 u-flex u-relative"
		>
			<div data-at="limits-notification-icon-wrapper" className="limits-notification-icon-wrapper">
				<Icon type={ICON_WARNING_LINE} className="limits-notification-icon" />
			</div>
			<div data-at="limits-notification-message-wrapper" className="limits-notification-message-wrapper">
				{updateTime && <small data-at="limit-notification-update-time">{updateTime}</small>}
				<span data-at="limit-notification-message">{message}</span>
			</div>
			{typeof iconCloseCallback === 'function' && (
				<div className="u-absolute u-pos-tr0">
					<IconButtonClose
						dataAt="limit-notification-icon-close"
						className="icon-close--small"
						onClick={iconCloseCallback}
					/>
				</div>
			)}
		</div>
	</li>
);

export default LimitNotification;
